import { format, formatDistanceStrict, parseISO } from "date-fns";

export const formatDate = (value?: string | null): string => {
  if (!value) return "—";
  // Treat bare datetime strings (no tz info) as UTC so local conversion is correct.
  const normalized = /[Z+]/.test(value) ? value : value + "Z";
  return format(parseISO(normalized), "MMM d, yyyy h:mm a");
};

export const formatMs = (value?: number | null): string => {
  if (value === null || value === undefined) return "—";
  if (value < 1000) return `${value} ms`;
  return `${(value / 1000).toFixed(2)} s`;
};

export const formatCost = (value?: number | null): string => {
  if (value === null || value === undefined) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  }).format(value);
};

export const formatShortId = (value?: string | null): string => {
  if (!value) return "—";
  return `${value.slice(0, 8)}...`;
};

export const formatDuration = (
  startedAt?: string | null,
  endedAt?: string | null
): string => {
  if (!startedAt || !endedAt) return "—";
  return formatDistanceStrict(parseISO(startedAt), parseISO(endedAt));
};
